var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bannerEmbed.bannerItems && _vm.bannerEmbed.bannerItems.length)?_c('div',{staticClass:"sabc_article_sidebar_embed"},[_c('div',{staticClass:"add_embed_code"},_vm._l((_vm.bannerEmbed.bannerItems),function(embed){return _c('div',[_c('div',{domProps:{"innerHTML":_vm._s(embed.content)}})])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }